/**
 * PÁGINA DE LOGOUT
 * 
 * Cierra sesión global y redirige al login.
 * Mata la sesión para TODAS las apps.
 */

/**
 * PÁGINA DE LOGOUT
 * 
 * Cierra sesión global y redirige al login.
 * Mata la sesión para TODAS las apps.
 */

import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { supabase } from '@shared/lib/supabaseClient';
import { redirectToLogin, getAppConfig } from '@shared/navigation';
import AuthLayout from '../components/AuthLayout';
import { useDynamicBranding } from '../hooks/useDynamicBranding';

const LogoutPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const app = searchParams.get('app') || undefined;
  useDynamicBranding(app ?? null);

  useEffect(() => {
    const performLogout = async () => {
      try {
        await supabase.auth.signOut();
        if (app) {
          const appConfig = getAppConfig(app);
          const returnTo = appConfig?.url;
          redirectToLogin(app, returnTo);
        } else {
          redirectToLogin();
        }
      } catch (error) {
        console.error('Error durante logout:', error);
        if (app) {
          const appConfig = getAppConfig(app);
          redirectToLogin(app, appConfig?.url);
        } else {
          window.location.href = '/login';
        }
      }
    };

    performLogout();
  }, [app]);

  return (
    <AuthLayout>
      <div className="auth-container">
        <div className="auth-header">
          <h1 className="auth-title">Cerrando sesión...</h1>
          <p className="auth-subtitle">Por favor espera</p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default LogoutPage;
